import React from 'react';
import DirectNavigationModel from '../DirectNavigationModel';
import SpaceView from '../SpaceView/SpaceView.react';
import {PropTypes} from 'prop-types';
import LocaleContext from '../../../../../Contexts/Locale/Context';

import './SpacesView.less';

class SpacesView extends React.PureComponent {
    _onSpaceClick = (space, group) => {
        if (this.props.onSpaceClick) {
            this.props.onSpaceClick(space, group);
        }
    };

    render() {
        // uses groupLabels for translations -- don't sort!
        let usesTableOverride = this.props.spaces.some((space) => space.labelTableOverride);

        return (
            <LocaleContext.Consumer>
                {(getTranslation) => {
                    if (!usesTableOverride) {
                        this.props.spaces.sort((a, b) =>
                            getTranslation('spaceLabels', a.spaceType).localeCompare(
                                getTranslation('spaceLabels', b.spaceType)
                            )
                        );
                    }

                    return (
                        <ul className={'Spaces'}>
                            {this.props.spaces.map((space) => {
                                return (
                                    <SpaceView
                                        space={space}
                                        key={space.id}
                                        onSpaceClick={this._onSpaceClick}
                                        useMediaGateway={this.props.useMediaGateway}
                                    />
                                );
                            })}
                        </ul>
                    );
                }}
            </LocaleContext.Consumer>
        );
    }
}

SpacesView.propTypes = {
    spaces: PropTypes.arrayOf(DirectNavigationModel.spaceType).isRequired,
    onSpaceClick: PropTypes.func,
    useMediaGateway: PropTypes.bool,
};

export default SpacesView;
